/** Input types that take no typing, so shortcuts stay with the palette there. */
const NON_TEXT_INPUT_TYPES = ["button", "checkbox", "radio", "submit", "reset", "file", "range", "color"];

/** True on macOS/iOS (for ⌘ vs Ctrl labels). */
export function isApplePlatform(): boolean {
  if (typeof navigator === "undefined") return false;
  const platform = (navigator as Navigator & { userAgentData?: { platform?: string } }).userAgentData?.platform ?? navigator.platform ?? "";
  return /mac|iphone|ipad|ipod/i.test(platform) || /Mac OS X/.test(navigator.userAgent);
}

export function isEditableTarget(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false;
  if (target.isContentEditable) return true;
  if (target instanceof HTMLTextAreaElement || target instanceof HTMLSelectElement) return true;
  if (target instanceof HTMLInputElement) return !NON_TEXT_INPUT_TYPES.includes(target.type);
  return false;
}

/**
 * Decides whether a keydown should open the palette: ⌘/Ctrl + K always;
 * ⌘/Ctrl + F only when the focus is not in an editable field (so the
 * browser's find keeps working there).
 */
export function isPaletteShortcut(e: Pick<globalThis.KeyboardEvent, "key" | "metaKey" | "ctrlKey" | "altKey" | "shiftKey" | "target">): boolean {
  if (!(e.metaKey || e.ctrlKey) || e.altKey || e.shiftKey) return false;
  const key = e.key.toLowerCase();
  if (key === "k") return true;
  if (key === "f") return !isEditableTarget(e.target);
  return false;
}
